import {FaBuilding, FaCalendar} from "react-icons/fa";
import {MdOutlineWorkOutline, MdSportsKabaddi} from "react-icons/md";
import {checkUserName} from "@/lib/helpers/userHelper";

export const monthsCalendar = [
    {
        id : 1,
        label : "Janvier",
        nbDays: 31,
        next : 2,
        prev : 12,
    },
    {
        id : 2,
        label : "Février",
        nbDays: 28,
        next : 3,
        prev : 1,
    },
    {
        id : 3,
        label : "Mars",
        nbDays: 31,
        next : 4,
        prev : 2,
    },
    {
        id : 4,
        label : "Avril",
        nbDays: 31,
        next : 5,
        prev : 3,
    },
    {
        id : 5,
        label: "Mai",
        nbDays: 30,
        next : 6,
        prev: 4,
    },
    {
        id : 6,
        label : "Juin",
        nbDays: 31,
        next : 7,
        prev: 5,
    },
    {
        id : 7,
        label : "Juillet",
        nbDays: 30,
        next : 8,
        prev : 6,
    },
    {
        id : 8,
        label : "Aout",
        nbDays: 31,
        next : 9,
        prev : 7
    },
    {
        id : 9,
        label : "Septembre",
        nbDays: 30,
        next : 10,
        prev: 8,
    },
    {
        id : 10,
        label : "Octobre",
        nbDays: 31,
        next : 11,
        prev : 9,
    },
    {
        id : 11,
        label : "Novembre",
        nbDays: 30,
        next : 12,
        prev: 10,
    },
    {
        id : 12,
        label : "Decembre",
        nbDays: 31,
        next : 1,
        prev: 11,
    }
]


export const weekdaysNames = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
//export const weekdaysNamesFrench = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];
export const weekdaysShortNames= ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];

export const filtersCalendar = [
    {
        id : 'ownLocation',
        label : "Mes locations",
        bgColor : '#38bdf8',
        txtColor : '#FFF',
        icon : FaBuilding
    },
    {
        id : 'reservationOwn',
        label : "Mes reservations d'offre",
        bgColor : '#4ade80',
        txtColor : '#FFF',
        icon : FaCalendar
    },
    {
        id : 'reservationTo',
        label : "Offres que j'ai vendu",
        bgColor : '#fb923c',
        txtColor : '#FFF',
        icon : FaCalendar
    },
    {
        id : 'openTraining',
        label : "OpenTrainings",
        bgColor : '#fbbf24',
        txtColor : '#FFF',
        icon : MdSportsKabaddi
    },
    {
        id : 'activities',
        label : "Activités",
        bgColor : '#6366f1',
        txtColor : '#FFF',
        icon : MdSportsKabaddi
    },
    {
        id : 'ownSession',
        label : "Mes seances",
        bgColor : '#c2410c',
        txtColor : '#FFF',
        icon : MdSportsKabaddi
    },
    {
        id : 'sessionTo',
        label : "Les séances",
        bgColor : '#134e4a',
        txtColor : '#FFF',
        icon : MdOutlineWorkOutline,
    },
]

export const weekdaysNamesFrench = [
    {id : 'monday', value: 'Lundi'},
    {id : 'tuesday', value: 'Mardi'},
    {id : 'wednesday', value: 'Mercredi'},
    {id : 'thursday', value: 'Jeudi'},
    {id : 'friday', value: 'Vendredi'},
    {id : 'saturday', value: 'Samedi'},
    {id : 'sunday', value: 'Dimanche'},

]


export function buildCalendarReservation(reservations){
    //console.log(reservations);
    //Composition array => locationUser, ... TODO
    let locationArray = [];
    let reservationsOwn = [];
    let reservationsTo = [];
    let reservationsOpenTraining = [];
    let reservationsActivities = [];
    let sessionOwn = [];
    let sessionTo = [];

    const locationParams = filtersCalendar.find(el => el.id === 'ownLocation');
    const reservationOwnParams = filtersCalendar.find(el => el.id === 'reservationOwn');
    const reservationToParams = filtersCalendar.find(el => el.id === 'reservationTo');
    const reservationOpenTrainingParams = filtersCalendar.find(el => el.id === 'openTraining');
    const reservationsActivitiesParams = filtersCalendar.find(el => el.id === 'activities');
    const sessionOwnParams = filtersCalendar.find(el => el.id === 'ownSession');
    const sessionToParams = filtersCalendar.find(el => el.id === 'sessionTo');


    locationArray = reworkArrayPart(reservations.locationUser, locationParams.bgColor,locationParams.txtColor, 'location', locationParams.id);
    reservationsOwn = reworkArrayPart(reservations.reservationFrom, reservationOwnParams.bgColor, reservationOwnParams.txtColor, 'reservation', reservationOwnParams.id);
    reservationsTo = reworkArrayPart(reservations.reservationTo, reservationToParams.bgColor, reservationToParams.txtColor, 'reservation', reservationToParams.id);
    sessionTo = reworkArrayPart(reservations.reservationSessionTo, sessionToParams.bgColor, sessionToParams.txtColor, 'reservation', sessionToParams.id);
    sessionOwn = reworkArrayPart(reservations.reservationSessionFrom, sessionOwnParams.bgColor, sessionOwnParams.txtColor, 'reservation', sessionOwnParams.id);
    reservationsOpenTraining = reworkArrayPart(reservations.openTrainings, reservationOpenTrainingParams.bgColor, reservationOpenTrainingParams.txtColor, 'openTraining', reservationOpenTrainingParams.id);
    reservationsActivities = reworkArrayPart(reservations.activities, reservationsActivitiesParams.bgColor, reservationsActivitiesParams.txtColor, 'activities', reservationsActivitiesParams.id);
    return simpleMerge(locationArray, reservationsOwn,reservationsTo,reservationsOpenTraining, reservationsActivities,sessionOwn,sessionTo);
}

function reworkArrayPart(array, colorBg,colorText, type, idExtraProps){
    let returnableArray = [];

    array.forEach(function(item){
        let title = '';
        let cible = null;
        let startTime = null;
        let endTime = null;
        let content = null;
        let validated = null;
        let deleted = false;
        switch(type){
            case 'location':
                title = item.location.title;
                startTime = item.start_time;
                endTime = item.end_time;
                content = item;
            break;
            case 'reservation':
                if(item.is_session){
                    validated = item.status;
                    const userToParams = checkUserName(item.user_to);
                    const userFromParams = checkUserName(item.user_from);

                    title = "["+(validated === 1 ? "Validé" : "En attente")+"] "+"Séance avec " + (idExtraProps === 'ownSession' ? userToParams.firstname + ' ' + userToParams.lastname : userFromParams.firstname + ' ' + userFromParams.lastname);
                }else{
                    const userParams = checkUserName(item.user_from);
                    title =  idExtraProps === "reservationTo" ? userParams.firstname + " " + userParams.lastname + " - " + item.offer.title : item.offer.title;
                }
                cible = item.user_from ?? null;
                deleted = (item.user_from === null || item.user_to === null);
                startTime = item.start_time;
                endTime = item.end_time;
                content = item;
            break;
            case 'openTraining':
                startTime = item.training.date_event;
                endTime = item.training.date_event_end;
                title = item.training.name;
                content = item.training;
            break;
            case 'activities':
                startTime = item.activity.date_event;
                endTime = item.activity.date_event_end;
                title = item.activity.title;
                content = item.activity;
                break;
            default:
                startTime = item.start_time;
                endTime = item.end_time;
            break;
        }

        returnableArray.push({
            id : item.id,
            title : title,
            start : startTime,
            end : endTime,
            backgroundColor : colorBg,
            textColor : colorText,
            extendedProps: {
                type : idExtraProps,
                category : type,
                deleted : deleted,
                originalId : item.id,
                cible : cible,
                content : content,
            }
        })
    })


    return returnableArray;
}


function simpleMerge(...arrays){
    return [].concat(...arrays);
}

